import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import '../CustamizedFilters/filterModule.css';

export default function DynamicAutoSearch({ open, options, handleOpen, handleSearch, handleChange, optLoading = '' }) {

  const loading = (optLoading === '') ? open && options.length === 0 : false;

  return (
    <div style={{ flex: 1, minWidth: 0, width: '100%' }}>
      <Autocomplete
        id="asynchronous-demo"
        open={open}
        onOpen={() => {
          handleOpen(true);
        }}
        onClose={() => {
          handleOpen(false);
        }}
        onChange={handleChange}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name}
        options={options}
        loading={loading}
        style={{ width: '100%' }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search"
            variant="outlined"
            fullWidth
            onChange={ev => {
              handleSearch(ev.target.value);
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </div>
  );
}